@if (isEmptyRoute && data ? true : false) {
  <div>
    @if (!IsCustomBreadCrumb) {
      <div class="breadcrumb-wrap">
        <ng-template #recursiveList let-list="list">
          @if (list.path === '') {
            @if (list.childern) {
              <a id="input-link-mbc-{{ list.name }}" (click)="handleParentClick(list.name)">{{ list.name ? list.name + ' /&nbsp;' : '' }}</a>
            } @else {
              <a>{{ list.name }}</a>
            }
          } @else {
            <a id="input-link-mbc-{{ list.name }}" [routerLink]="list.path">{{ list.name ? list.name + ' /&nbsp;' : '' }}</a>
          }
          @if (list.childern) {
            <ng-container *ngTemplateOutlet="recursiveList; context: { list: list.childern }"></ng-container>
          }
        </ng-template>
        <ng-container *ngTemplateOutlet="recursiveList; context: { list: data }"></ng-container>
      </div>
    }
    @if (IsCustomBreadCrumb) {
      <div class="breadcrumb-wrap">
        <a data-test-id="input-link-mbc-back" class="back-to-auth-link" (click)="CustomBreadCrumbClick()">{{ CustomBreadCrumbText }}</a>
      </div>
    }
    <h1 class="page-title">{{ data.title }}</h1>
  </div>
}
